"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Analytics Events
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnumConnectType = void 0;
exports.EnumConnectType = {
    Phone: 'Phone',
    Email: 'Email',
    Sms: 'SMS',
    Address: 'Address',
    Url: 'URL',
};
//# sourceMappingURL=enum-connect-type.js.map